import React from "react";
import type { DocumentLifecycleStatus } from "../../../api/frameworksApi";

/* ── Inline Lifecycle Stepper ── */
export function InlineLifecycle({
  currentStatus,
}: {
  currentStatus: DocumentLifecycleStatus;
}) {
  // Main workflow: DRAFT → IN_REVIEW → APPROVED → PUBLISHED
  // Terminal statuses: REVIEW_OVERDUE (from PUBLISHED), RETIRED (terminal)
  const mainSteps = ["DRAFT", "IN_REVIEW", "APPROVED", "PUBLISHED"] as const;
  const stepLabels: Record<string, string> = {
    DRAFT: "Draft",
    IN_REVIEW: "In Review",
    APPROVED: "Approved",
    PUBLISHED: "Published",
    RETIRED: "Withdrawn",
  };

  const isMainStatus = mainSteps.includes(
    currentStatus as (typeof mainSteps)[number],
  );
  const activeIdx = isMainStatus
    ? mainSteps.indexOf(currentStatus as (typeof mainSteps)[number])
    : mainSteps.length;

  return (
    <div className="ml-3 flex items-center gap-1">
      {mainSteps.map((s, i) => {
        const isCurrent = s === currentStatus;
        const isPast = activeIdx >= 0 && i < activeIdx;
        return (
          <React.Fragment key={s}>
            <div
              className={`flex items-center gap-1 ${isCurrent ? "text-foreground" : isPast ? "text-emerald-600 dark:text-emerald-400" : "d/40"}`}
            >
              <div
                className={`size-2 rounded-full ${isCurrent ? "bg-blue-500 ring-2 ring-blue-500/30" : isPast ? "bg-emerald-500" : "bg-muted-foreground/20"}`}
              />
              <span
                className={`text-[10px] ${isCurrent ? "font-bold" : "font-medium"}`}
              >
                {stepLabels[s]}
              </span>
            </div>
            {i < mainSteps.length - 1 && (
              <div
                className={`w-4 h-px ${isPast ? "bg-emerald-500/50" : "bg-muted-foreground/15"}`}
              />
            )}
          </React.Fragment>
        );
      })}
      {currentStatus === "RETIRED" && (
        <>
          <div className="w-4 h-px bg-muted-foreground/15" />
          <div className="flex items-center gap-1">
            <div className="size-2 rounded-full bg-slate-500" />
            <span className="text-[10px] font-bold text-slate-500 dark:text-slate-400">
              Withdrawn
            </span>
          </div>
        </>
      )}
    </div>
  );
}
